<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- A400系共通部品_Steps -->
    <app-c400-steps></app-c400-steps>

    <!----------------- 提案登録(課題) --------------------------------------------->
    <div *ngIf="1 == detailTask?.agenda_kbn.id">
      <!-- タイトル -->
      <div class="title">
        <h1>
          <label *ngIf="!confirmationFlag">提案登録</label>
          <label *ngIf="confirmationFlag">提案内容確認</label>
        </h1>
      </div>
      <!-- 課題一覧 -->
      <div class="task-list">
        <div class="p-d-flex header">
          <!-- <div class="p-as-left"> -->
          <div>
            <label>
              <label class="kadai-color">
                {{ detailTask?.title }}<br />
              </label>
            </label>
            <label class="task-organization_name">
              {{ detailTask?.organization_name }}
            </label>
            <p-tag value="課題" styleClass="task-tag"></p-tag>
          </div>
        </div>
        <div class="content">
          <ul class="task">
            <label *ngIf="1 == detailTask?.agenda_kbn.id">
              {{ detailTask?.agenda }}
            </label>
          </ul>
        </div>
      </div>
      <!-- 提案登録(C401) -->
      <div *ngIf="!confirmationFlag">
        <!-- 入力フォーム -->
        <form [formGroup]="c401InputForm">
          <!-- 提案情報 -->
          <div class="proposing-information">
            <!-- 備考 -->
            <!--fpt's part start: check box notify member -->
            <div class="note">提案内容をご記載ください。（提案内容は提案先にのみ通知されます。）
              <p-accordion class="p-mb-3">
                <p-accordionTab *ngIf="inputType=='new'"  header="課題を提案したい団体名にチェックしてください">
                  <span class="p-text-bold">チェックボックスのON/OFFに応じて、課題登録団体・課題をフォローしている団体を指定して、まとめて提案を送付できます。</span><br>
                  <div class="p-mb-3 p-d-flex p-flex-column p-jc-between">
                    <p-checkbox
                      class="checkbox-all"
                      label="課題登録団体に提案する"
                      [binary]="true"
                      [(ngModel)]="isNotifyOwner"
                      [disabled]="detailTask?.flag_batch_suggest == 0"
                      [ngModelOptions]="{standalone: true}"
                    >
                    </p-checkbox>
                    <p-checkbox
                    *ngIf="detailTask?.flag_batch_suggest == 1"
                      class="checkbox-all"
                      label="全フォロー団体にチェックON/OFF"
                      [binary]="true"
                      (onChange)="checkAllFollowed($event)"
                      [(ngModel)]="mainCB"
                      [ngModelOptions]="{standalone: true}"
                      [disabled]="listFollow?.length <= 0"
                    >
                    </p-checkbox>
                  </div>
                  <div *ngIf="detailTask?.flag_batch_suggest == 1" class="follow-wrapper p-px-4">
                    <div class="follow-container p-grid">
                      <div class="p-col-3 p-jc-center cell" *ngFor="let item of listFollow,index as i">
                        <p-checkbox
                          [label]="item.organization_name"
                          name="cb{{i}}"
                          [(ngModel)]="item.checked"
                          [ngModelOptions]="{standalone: true}"
                          [binary]="true"
                          (onChange)="isAllChecked()"
                        >
                        </p-checkbox>
                      </div>
                    </div>
                  </div>
                  <p class=" platform-warning-text p-mx-3 p-my-1" *ngIf="detailTask?.flag_batch_suggest == 1 && listChosed.length > getmaxCount()">
                    既定の数を超えて選択されています。
                  </p>
                </p-accordionTab>
              </p-accordion>
            </div>
            <!--fpt's part end-->
            <!-- 提案内容 -->
            <p-table [value]="[{}]" styleClass="information-Form">
              <ng-template pTemplate="body">
                <!-- 提案タイトル -->
                <tr>
                  <td class="item-input-name">
                    提案タイトル<span class="required">【必須】</span>
                  </td>
                  <td class="item-label-name"></td>
                  <td class="item-information">
                    <div class="warning-text">
                      ※提案タイトルを
                      <label class="warning">50字</label>
                      以内でご記載ください
                    </div>
                    <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="title" />
                    <!-- エラーメッセージ出力箇所 -->
                    <app-validator-message [control]="c401InputForm.get('title')">
                    </app-validator-message>
                  </td>
                </tr>
                <!-- 提案内容 -->
                <tr>
                  <td class="item-input-name">
                    提案内容<span class="required">【必須】</span>
                  </td>
                  <td class="item-label-name"></td>
                  <td class="item-information">
                    <div class="warning-text">
                      ※提案内容の詳細を
                      <label class="warning">400字</label>以内でご記載ください
                    </div>
                    <textarea pInputTextarea class="information-Form-inputtext-wMax"
                      formControlName="detail"></textarea>
                    <!-- エラーメッセージ出力箇所 -->
                    <app-validator-message [control]="c401InputForm.get('detail')">
                    </app-validator-message>
                  </td>
                </tr>
                <!-- 導入事例・実績等 -->
                <tr>
                  <td class="item-input-name">
                    導入事例・実績等
                    <!-- <span class="required">【必須】</span> -->
                  </td>
                  <td class="item-label-name"></td>
                  <td class="item-information">
                    <div class="warning-text">
                      ※導入事例・実績等の概要を
                      <label class="warning">400字</label>以内でご記載ください
                    </div>
                    <textarea pInputTextarea class="information-Form-inputtext-wMax" formControlName="case"></textarea>
                    <!-- エラーメッセージ出力箇所 -->
                    <app-validator-message [control]="c401InputForm.get('case')">
                    </app-validator-message>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </form>
      </div>
    </div>

    <!----------------- 依頼登録(ソリューション) --------------------------------------------->
    <div *ngIf="2 == detailTask?.agenda_kbn.id">
      <!-- タイトル -->
      <div class="title">
        <h1>
          <label *ngIf="!confirmationFlag">依頼登録</label>
          <label *ngIf="confirmationFlag">依頼内容確認</label>
        </h1>
      </div>
      <!-- 課題一覧 -->
      <div class="task-list">
        <div class="p-d-flex header">
          <!-- <div class="p-as-left"> -->
          <div>
            <label *ngIf="2 == detailTask?.agenda_kbn.id">
              <label class="solution-color">
                {{ detailTask?.title }}<br />
              </label>
            </label>
            <label class="task-organization_name">
              {{ detailTask?.organization_name }}
            </label>
            <p-tag value="ソリューション" styleClass="solution-tag" *ngIf="2 == detailTask?.agenda_kbn.id"></p-tag>
          </div>
        </div>
        <div class="content">
          <ul class="task">
            <label *ngIf="2 == detailTask?.agenda_kbn.id">
              {{ detailTask?.solution_detail }}
            </label>
          </ul>
        </div>
      </div>
      <!-- 提案登録(C401) -->
      <div *ngIf="!confirmationFlag">
        <!-- 入力フォーム -->
        <form [formGroup]="c401InputForm">
          <!-- 提案情報 -->
          <div class="proposing-information">
            <!-- 備考 -->
            <div class="note">依頼内容をご記載ください。（依頼内容は依頼先にのみ通知されます。）</div>

            <!-- 提案内容 -->
            <p-table [value]="[{}]" styleClass="information-Form">
              <ng-template pTemplate="body">
                <!-- 提案タイトル -->
                <tr>
                  <td class="item-input-name">
                    依頼タイトル<span class="required">【必須】</span>
                  </td>
                  <td class="item-label-name">
                    <p-tag value="公開" styleClass="public-tag"></p-tag>
                  </td>
                  <td class="item-information">
                    <div class="warning-text">
                      ※依頼タイトルを
                      <label class="warning">50字</label>
                      以内でご記載ください
                    </div>
                    <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="title"
                      placeholder="例）○○サービスの利用について（ご相談）" />
                    <!-- エラーメッセージ出力箇所 -->
                    <app-validator-message [control]="c401InputForm.get('title')">
                    </app-validator-message>
                  </td>
                </tr>
                <!-- 提案内容 -->
                <tr>
                  <td class="item-input-name">
                    依頼内容<span class="required">【必須】</span>
                  </td>
                  <td class="item-label-name">
                    <p-tag value="公開" styleClass="public-tag"></p-tag>
                  </td>
                  <td class="item-information">
                    <div class="warning-text">
                      ※依頼内容の詳細を
                      <label class="warning">400字</label>以内でご記載ください
                    </div>
                    <textarea pInputTextarea class="information-Form-inputtext-wMax p-text-area-400"
                      formControlName="detail" placeholder="ソリューションを利用して解決したい課題をご記載ください。"></textarea>
                    <!-- エラーメッセージ出力箇所 -->
                    <app-validator-message [control]="c401InputForm.get('detail')">
                    </app-validator-message>
                  </td>
                </tr>
                <!-- 質問事例 -->
                <tr>
                  <td class="item-input-name">質問事項</td>
                  <td class="item-label-name">
                    <p-tag value="公開" styleClass="public-tag"></p-tag>
                  </td>
                  <td class="item-information">
                    <div class="warning-text">
                      ※ソリューションに対する質問等がある場合、
                      <label class="warning">200字</label>以内でご記載ください
                    </div>
                    <textarea pInputTextarea class="information-Form-inputtext-wMax p-text-area-200"
                      formControlName="question"
                      placeholder="例）貴団体の登録ソリューションは、中山間地でも利用可能でしょうか。&#13;&#10;&emsp;&emsp;利用方法等にかかる人材育成支援は可能でしょうか。">
                    </textarea>
                    <!-- エラーメッセージ出力箇所 -->
                    <app-validator-message [control]="c401InputForm.get('question')">
                    </app-validator-message>
                  </td>
                </tr>
                <!-- 参考情報 -->
                <tr>
                  <td class="item-input-name">参考情報</td>
                  <td class="item-label-name">
                    <p-tag value="公開" styleClass="public-tag"></p-tag>
                  </td>
                  <td class="item-information">
                    <div class="warning-text">
                      ※参考情報を
                      <label class="warning">400字</label>以内でご記載ください
                    </div>
                    <textarea pInputTextarea class="information-Form-inputtext-wMax p-text-area-400"
                      formControlName="reference" placeholder="関連情報のURL、課題に対するこれまでの取組み等をご記載ください。"></textarea>
                    <!-- エラーメッセージ出力箇所 -->
                    <app-validator-message [control]="c401InputForm.get('reference')">
                    </app-validator-message>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </form>
      </div>
    </div>

    <!-- ヴァリデーションチェックメッセージエリア -->
    <div class="p-d-flex p-jc-center error-area" *ngIf="!c401InputForm.valid||(!isNotifyOwner && listChosed.length<=0)||listChosed.length>getmaxCount()">
      <label class="warning platform-warning-text">
        未入力の項目、またはエラーがあります。
      </label>
    </div>
    <!-- エラーがない場合のボタン位置統一用 -->
    <div class="p-d-flex p-jc-center error-area" *ngIf="c401InputForm.valid&&!(!isNotifyOwner && listChosed.length<=0)&&listChosed.length<getmaxCount()">
      <label class="warning platform-warning-text">
        &nbsp;
      </label>
    </div>

    <div *ngIf="!confirmationFlag">
      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center button-area">
        <button pButton type="button" label="確認画面へ進む" class="button-default-size button1"
          [disabled]="!c401InputForm.valid || !isNotifyOwner && (listChosed.length<=0) || listChosed.length > getmaxCount()" (click)="moveC402()"></button>
      </div>
    </div>

    <!------------------------------------------------------------------------->

    <!-- 提案登録確認(C402) -->
    <div *ngIf="confirmationFlag">

      <!---------- 提案 ------------>
      <div *ngIf="1 == detailTask?.agenda_kbn.id">
        <!-- 提案情報 -->
        <div class="proposing-information">
          <!-- 備考 -->
          <div class="note">提案内容をご確認ください。</div>

          <!-- 提案内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- 提案タイトル -->
              <tr>
                <td class="item-input-name">提案タイトル</td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  {{ c401InputForm.value.title }}
                </td>
              </tr>
              <!-- 提案内容 -->
              <tr>
                <td class="item-input-name">提案内容</td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  {{ c401InputForm.value.detail }}
                </td>
              </tr>
              <!-- 導入事例・実績等 -->
              <tr>
                <td class="item-input-name">導入事例・実績等</td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  {{ c401InputForm.value.case }}
                </td>
              </tr>
              <!-- fpt's part start: member to notify -->
              <tr>
                <td class="item-input-name">提案先<span *ngIf="inputType=='new'">（課題登録団体）</span></td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  <span >{{isNotifyOwner? detailTask.organization_name:'－'}}</span>
                </td>
              </tr>
              <tr *ngIf="detailTask?.flag_batch_suggest == 1 && inputType=='new'">
                <td class="item-input-name">提案先（フォロー団体）</td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  <ng-container *ngIf="listChosed.length > 0;else hasChosed">
                    <span *ngFor="let item of listChosed;index as i">
                      {{ item.organization_name }}<span *ngIf="i < listChosed.length-1">,</span>
                    </span>
                  </ng-container>
                  <ng-template #hasChosed>
                    －
                  </ng-template>
                </td>
              </tr>
              <!-- fpt's part end -->
            </ng-template>
          </p-table>
        </div>
      </div>
      <!---------- 依頼 ------------>
      <div *ngIf="2 == detailTask?.agenda_kbn.id">
        <!-- 提案情報 -->
        <div class="proposing-information">
          <!-- 備考 -->
          <div class="note">依頼内容をご確認ください。</div>

          <!-- 提案内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- 提案タイトル -->
              <tr>
                <td class="item-input-name">依頼タイトル</td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  {{ c401InputForm.value.title }}
                </td>
              </tr>
              <!-- 提案内容 -->
              <tr>
                <td class="item-input-name">依頼内容</td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  {{ c401InputForm.value.detail }}
                </td>
              </tr>
              <!-- 質問事項 -->
              <tr>
                <td class="item-input-name">質問事項</td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  {{ c401InputForm.value.question }}
                </td>
              </tr>
              <!-- 参考情報 -->
              <tr>
                <td class="item-input-name">参考情報</td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  {{ c401InputForm.value.reference }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <!-- エラーがない場合のボタン位置統一用 -->
      <div class="p-d-flex p-jc-center error-area">
        <label class="warning platform-warning-text">
          &nbsp;
        </label>
      </div>



      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center button-area">
        <button pButton type="button" label="修正する" class="button-default-size button2" (click)="moveC401()"></button>
        <button pButton type="button" label="登録する" class="button-default-size button1" (click)="moveC403()"></button>
      </div>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
